"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchError = void 0;
class FetchError extends Error {
    constructor(response, data) {
        super(`[${response.status}]: ${response.statusText}`);
        this.status = response.status;
        this.statusText = response.statusText;
        this.headers = response.headers;
        this.data = data;
    }
    static create(response) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const data = ((_a = response.headers
                .get('content-type')) === null || _a === void 0 ? void 0 : _a.startsWith('application/json'))
                ? yield response.json()
                : undefined;
            return new FetchError(response, data);
        });
    }
}
exports.FetchError = FetchError;
//# sourceMappingURL=fetch-error.js.map